import React, { useState } from 'react'
import styled from 'styled-components'
import { Dropdown, MenuItem } from './Dropdown'
import languageIcon from '../../icons/language.svg'
import { setAppContentLanguage } from '../../redux/actions'
import { connect } from 'react-redux'
import { getAppContentLanguage } from '../../redux/selectors'

const languages = {
  no: {
    name: 'Norsk',
    shortName: 'NO',
    id: 'no',
  },
  en: {
    name: 'English',
    shortName: 'EN',
    id: 'en',
  },
}

const LanguageSelector = ({ setLanguage, language, Backdrop, selected, onToolClicked }) => {

  const [isOpen, setIsOpen] = useState(selected)
  const { name, shortName } = languages[language]

  return (
    <Wrapper>
      <ActiveLanguage onClick={() => onToolClicked()}>
        <Icon src={languageIcon} alt={name} />
        {shortName}
      </ActiveLanguage>
      {isOpen && (
        <>
          <Backdrop />
          <Dropdown>
            {Object.values(languages).map(({ name, id }) => (
              <MenuItem
                key={name}
                onClick={() => {
                  setLanguage(id)
                  setIsOpen(false)
                }}
              >
                <span>{name}</span>
              </MenuItem>
            ))}
          </Dropdown>
        </>
      )}
    </Wrapper>
  )
}

const ActiveLanguage = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  border: none;
  color: inherit;
  transform: translateY(0.125em);
  &:hover {
    opacity: 0.8;
  }
`

const Icon = styled.img`
  height: 2.5em;
  margin-right: 0.1em;
`

const Wrapper = styled.div`
  position: relative;
`


const mapStateToProps = (state) => {
  return {
    language: getAppContentLanguage(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return { 
    setLanguage: (language) => dispatch(setAppContentLanguage(language)) 
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector)

